import { Outlet, NavLink } from "react-router-dom";
import { LayoutDashboard, Flame, Sparkles, Compass, Inbox } from "lucide-react";
import Sidebar from "@/components/Sidebar";

const MOBILE_NAV = [
  { to: "/admin", label: "Übersicht", icon: LayoutDashboard, end: true },
  { to: "/admin/deals", label: "Deals", icon: Flame },
  { to: "/admin/submissions", label: "Inbox", icon: Inbox },
  { to: "/admin/content", label: "Content", icon: Sparkles },
  { to: "/admin/niches", label: "Nischen", icon: Compass },
];

export default function Layout() {
  return (
    <div className="flex min-h-screen bg-[#F5F5F7]">
      <Sidebar />
      <main className="flex-1 min-w-0 pb-24 md:pb-0">
        <Outlet />
      </main>

      {/* Mobile bottom nav */}
      <nav className="md:hidden fixed bottom-0 inset-x-0 z-50 glass-header border-t border-black/5 flex">
        {MOBILE_NAV.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `flex-1 flex flex-col items-center gap-1 py-2.5 text-[10px] font-medium transition-colors ${
                  isActive ? "text-[#0071E3]" : "text-[#86868B]"
                }`
              }
            >
              <Icon className="h-5 w-5" strokeWidth={2} />
              {item.label}
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
}
